import {
  EditListIcon,
  GlobeCheckmarkIcon,
  InfoIcon,
  TableChip,
} from "components";

type RecordVisibility = "public" | "draft" | "private" | "unsaved";

interface KbRecordVisibilityChipProps {
  visibility: RecordVisibility;
}

export const KbRecordVisibilityChip = ({
  visibility,
}: KbRecordVisibilityChipProps) => {
  const visibilityConfig = {
    public: {
      icon: (
        <GlobeCheckmarkIcon
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      ),
      content: "Published",
      type: "success" as const,
    },
    private: {
      icon: (
        <EditListIcon
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      ),
      content: "Draft",
      type: "neutral" as const,
    },
    draft: {
      icon: (
        <EditListIcon
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      ),
      content: "Draft",
      type: "neutral" as const,
    },
    unsaved: {
      icon: (
        <InfoIcon
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      ),
      content: "Private draft",
      type: "warning" as const,
    },
  };

  const config = visibilityConfig[visibility] || visibilityConfig.private;

  return (
    <TableChip
      containerStyle={{
        width: "max-content",
        minWidth: "102px",
      }}
      startIcon={config.icon}
      content={config.content}
      type={config.type}
    />
  );
};
